import React from "react";
import { faq } from "../../mock";
import useReveal from "../../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export default function Faq() {
  const ref = useReveal();

  return (
    <section className="section" id="faq" ref={ref} style={{ paddingTop: "3rem" }}>
      <div className="faq-wrap">
        <div className="section-head" data-reveal>
          <h2 className="section-title" style={{ fontSize: "clamp(2rem, 4.5vw, 3.6rem)" }}>
            Въпроси<span className="annotation">(преди да започнем)</span>
          </h2>
          <span className="section-num">05.</span>
        </div>

        <div data-reveal>
          <Accordion type="single" collapsible className="w-full">
            {faq.map((item, i) => (
              <AccordionItem value={`item-${i}`} key={i}>
                <AccordionTrigger className="faq-question text-left">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
